<template>
  <div class="leaderboard component">
    <overlay
      :is-loading="isLoading"
    />
    <div
      v-for="(userMegaLeague, index) in userMegaLeagueCollection"
      :key="userMegaLeague.user.slug"
    >
      <v-divider
        v-if="index !== 0"
        inset
      />
      <leaderboard-row
        :user-mega-league="userMegaLeague"
        :is-self="isSelf(userMegaLeague)"
        :rank="rank(index)"
        @open-user-lineup-dialog="openUserLineupDialog"
      />
    </div>
    <v-pagination
      v-if="!isLoading"
      v-model="page"
      :length="paginationLength"
      :total-visible="7"
      :disabled="isLoading"
      dark
      next-icon="fa-chevron-right"
      prev-icon="fa-chevron-left"
    />
    <user-lineup-dialog
      v-model="displayUserLineupDialog"
      :is-loading="isLoadingDialog"
      :user-mega-league="selectedUserMegaLeague"
    />
  </div>
</template>

<script>
import Overlay from '@/components/Overlay.vue';
import LeaderboardRow from '@/components/MegaLeague/LeaderboardRow.vue';
import MegaLeagueService from '@/services/megaLeague.service';
import Gameweek from '@/models/GameWeek/gameWeek';
import UserLineupDialog from '@/components/UserLineupDialog.vue';
import { useUserStore } from '@/store/user.module';


export default {
  name: 'Leaderboard',
  components: {
    Overlay,
    LeaderboardRow,
    UserLineupDialog,
  },
  props: {
    gameWeek: {
      type: Gameweek,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      paginatedUserMegaLeagueCollection: null,
      page: 1,
      currentUser: useUserStore().currentUser,
      isLoadingDialog: false,
      selectedUserMegaLeague: null,
      displayUserLineupDialog: false,
    };
  },
  computed: {
    userMegaLeagueCollection() {
      return this.paginatedUserMegaLeagueCollection?.userMegaLeagueCollection ?? [];
    },
    count() {
      return this.paginatedUserMegaLeagueCollection?.count ?? 0;
    },
    paginationLength() {
      return Math.ceil(this.count / 10);
    },
  },
  watch: {
    page() {
      this.getMegaLeagueLeaderboard();
    },
    gameWeek() {
      this.getMegaLeagueLeaderboard();
    },
  },
  mounted() {
    if (this.isLoading) {
      this.getMegaLeagueLeaderboard();
    }
  },
  methods: {
    rank(index) {
      return ((this.page - 1) * 10) + index + 1;
    },
    isSelf(userMegaLeague) {
      return userMegaLeague.user.nickname === this.currentUser.nickname;
    },
    getMegaLeagueLeaderboard() {
      MegaLeagueService.getLeaderboard(this.gameWeek.number, this.page)
        .then((response) => this.paginatedUserMegaLeagueCollection = response)
        .catch(() => this.paginatedUserMegaLeagueCollection = null)
        .finally(() => this.isLoading = false);
    },
    openUserLineupDialog(userMegaLeague) {
      this.displayUserLineupDialog = true;
      this.isLoadingDialog = true;

      MegaLeagueService.getUserMegaLeagueByUser(this.gameWeek.number, userMegaLeague.user.slug)
        .then((data) => {
          this.selectedUserMegaLeague = data;
        })
        .finally(() => {
          this.isLoadingDialog = false;
        });
    },
  },
};
</script>

<style scoped>
.leaderboard {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
}
</style>
